export default __webpack_public_path__ + "static/media/facebook.a4e0371d.svg";